import { Six_To_12_Options } from './../../../../shared/constants/mad-libs/dimension1-options/6-to-12-options.constant';
import { Six_to_8_Options } from './../../../../shared/constants/mad-libs/dimension1-options/6-to-8-options.constant';
import { Nine_To_12_Options } from './../../../../shared/constants/mad-libs/dimension1-options/9-to-12-options.constant';
import { K_to_5_Options } from './../../../../shared/constants/mad-libs/dimension1-options/k-to-5-options.constant';
import { K_To_8_Options } from './../../../../shared/constants/mad-libs/dimension1-options/k-to-8-options.constant';
import {
  emsFlagOptions,
  emsPointPeopleOptions,
  hsFlagOptions,
  hsPointPeopleOptions,
} from './my-students-mad-lib-options.constant';

export const DIMENSION_1 = {
  madLib: 'Dimension1',
  options: {
    'K to 5': K_to_5_Options,
    'K to 8': K_To_8_Options,
    '6 to 8': Six_to_8_Options,
    '6 to 12': Six_To_12_Options,
    'Large HS': Nine_To_12_Options,
    'Small HS': Nine_To_12_Options,
    Charter: Nine_To_12_Options,
    Transfer: Nine_To_12_Options,
  },
  helperText: 'focused on',
};

export const DIMENSION_2 = {
  madLib: 'Dimension2',
  options: {
    ES: [...emsFlagOptions, ...emsPointPeopleOptions],
    MS: [...emsFlagOptions, ...emsPointPeopleOptions],
    HS: [...hsFlagOptions, ...hsPointPeopleOptions],
  },
};

// RESOLVER CONFIG
export const MY_STUDENTS_MADLIB_CONFIG = {
  DIMENSION_1,
  DIMENSION_2,
  listType: 'MY_STUDENTS',
  dimensionsAreIndependent: false,
  hasDimensionParams: $stateParams => {
    const { Dimension1, Dimension2 } = $stateParams;
    const hasDimensionParams = !!(Dimension1 && Dimension2);
    return hasDimensionParams;
  },
};
